import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';
import Form from '@atlaskit/form';
import FieldGroup from '../../../../../components/FieldGroup';

export const PrivacyPolicyContainer = styled.div`
  margin-top: ${gridSize()}px;
  text-align: left;
  margin-left: 6px;
`;

export const PasswordFieldGroup = styled(FieldGroup)<{
  isHidden?: boolean;
}>`
  padding-top: ${({ isHidden }) => (isHidden ? `${gridSize() * 2}px` : 0)};
`;

export const WelcomeButtonWrapper = styled.div`
  margin-top: ${gridSize()}px;
`;

export const TitleWrapper = styled.div`
  text-align: center;
  padding-top: 4px;
`;

export const StyledForm = styled(Form)`
  margin: 0;
`;
